import { render } from "./StandardComponent.vue?vue&type=template&id=35c5483e&scoped=true"
import script from "./StandardComponent.vue?vue&type=script&lang=js"
export * from "./StandardComponent.vue?vue&type=script&lang=js"

import "./StandardComponent.vue?vue&type=style&index=0&id=35c5483e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35c5483e"]])

export default __exports__